const Down = () => (
   <svg viewBox='0 0 256 256' width='16' height='16'>
      <rect width='256' height='256' fill='none'></rect>
      <line
         fill='none'
         stroke='currentColor'
         strokeLinecap='round'
         strokeLinejoin='round'
         strokeWidth='24'
         x1='128'
         x2='128'
         y1='40'
         y2='216'
      ></line>
      <polyline
         fill='none'
         points='56 144 128 216 200 144'
         stroke='currentColor'
         strokeLinecap='round'
         strokeLinejoin='round'
         strokeWidth='24'
      ></polyline>
   </svg>
);
export default Down;
